import React, {useContext, useMemo} from 'react';

import {mapDateFormat} from 'src/utils/mapDateFormat';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';
import {FormattedDate} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';


type Props = {
    timestamp: string,
};

export const ChangeLogTimestampCell = ({timestamp}: Props) => {
    const {locale} = useContext(LocaleContext);

    const value = useMemo(
        () => FormattedDate.format({
            value: timestamp,
            format: mapDateFormat(locale.dateFormat, 'WORD', 'DATE_TIME')}) || '',
        [timestamp, locale.dateFormat],
    );

    return (
        <EllipsisTextHint title={value}>{value}</EllipsisTextHint>
    );
};
